import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
	faCaretRight, 
	faCaretLeft, 
	faAngleLeft,
	faAngleRight, 
	faBackwardFast,
	faForwardFast,
	faQuestion,
	faXmark
} from '@fortawesome/free-solid-svg-icons';
import './HelpInfoOverlay.css';

type HelpInfoOverlayPropsType = {
	screenSize: string;
};

function HelpInfoOverlay( {
	screenSize,
}:HelpInfoOverlayPropsType ) {
	let [overlayVisible, setOverlayVisible] = useState(false);
	
	let prevNextDayButtons = screenSize === 'sm' ? 
		<span>
			<span className="buttonIcon"><FontAwesomeIcon icon={faAngleLeft} /></span>/
			<span className="buttonIcon"><FontAwesomeIcon icon={faAngleRight} /></span>
		</span>
		:
		<span>
			<span className="buttonIcon">Prev. Day</span>/
			<span className="buttonIcon">Next Day</span>
		</span>;

	let buttonsUsage = <p>Use the {prevNextDayButtons} buttons to go back or forward by a single day, the <span className="buttonIcon"><FontAwesomeIcon icon={faCaretLeft} /></span>/<span className="buttonIcon"><FontAwesomeIcon icon={faCaretRight} /></span> buttons to play the series backwards or forwards, and the <span className="buttonIcon"><FontAwesomeIcon icon={faBackwardFast} /></span>/<span className="buttonIcon"><FontAwesomeIcon icon={faForwardFast} /></span> buttons to jump to the beginning or end of the timeline.</p>
	
	return (
		<div>
			<div 
				className={ "helpInfoOverlayContainer"+( overlayVisible ? " helpInfoOverlayVisible" : "" ) }
				data-testid="helpInfoOverlayContainer"
			>
				<div className="overlayScrollContainer">
					<h1>Information</h1>
					<p>This is a viewer for weight loss progress pictures taken over the course of roughly 11 months. The images were stabilized using OpenCV.</p>
					{ buttonsUsage }
					<p>The chart shows weight (y-axis) vs date (x-axis). Red dots represent cheat days, days where I ate over my target of 1600 calories. No strict calorie tracking was done, just rough estimates using my eyecrometers.</p>
					<p>Navigation can also be accomplished by using the the Left Arrow and Right Arrow keys, and by clicking/hovering on the graph.</p>
				</div>
			</div>
			<button 
				aria-label={ overlayVisible ? "Hide Help" : "Show Help"}
				className="helpInfoOverlayToggleButton"
				onClick={ () => {
					setOverlayVisible( overlayVisible => !overlayVisible );
				}}
			>
				{
					overlayVisible ?
						<FontAwesomeIcon icon={faXmark} />
						:
						<FontAwesomeIcon icon={faQuestion} />
				}
			</button>
		</div>
  );
}

export default HelpInfoOverlay;
